export default __webpack_public_path__ + "static/media/star-empty.d73cf242.svg";